export function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}


export function throttle(callback, interval) {
  let enableCall = true;

  return function(...args) {
	if (!enableCall) return;

	enableCall = false;
	callback.apply(this, args);
	setTimeout(() => enableCall = true, interval);
  }
}




// WEBPACK FOOTER //
// ./scripts/util/utils.js